<script setup lang="ts">
import { computed } from 'vue';
import { useHalFeatures } from '@apparatix/stores/useHalFeatures';
import type { HalFeature } from '@apparatix/types/HalOptions';

type Props = {
  /**
   * If an array is passed to this prop, the user must have every feature in the array
   * in order to see the gated content
   */
  has: HalFeature | HalFeature[];
}

const props = defineProps<Props>();

const store = useHalFeatures();

const enabled = computed(() => {
  if (!props.has) return false;

  if (Array.isArray(props.has)) {
    return props.has.every(feature => store.hasFeature(feature));
  }

  return store.hasFeature(props.has);
});
</script>
<template>
  <slot v-if="enabled" />
  <slot v-else name="fallback" />
</template>
